// removed by extract-text-webpack-plugin
module.exports = {"fails":"PR9OuLnr35lwf6y-d7fa7","view":"_2aXEBr-fv8mPdIIP_V2NrL","Icon":"_2mrskRyYng7-zB3Z4kf2R6","Title":"_1Skt6FRWxwwKJexeqAC0fr","Title2":"_3VQfDU3jWuSHDWmtaQgp7Z","button":"_1Nw99lhdZNPZJLpibcV12Y"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/MassiveUpload/styles.css
// module id = 2737
// module chunks = 0